<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-users-cog" texto-titulo="Nuevo usuario"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarUsuario()">
          <float-label label="Denominación:">
            <input
              v-model="usuario.denominacion"
              id="denominacion"
              placeholder="Ingresar un denominación..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.usuario.denominacion.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.usuario.denominacion.required"
              >Debe ingresar la denominación </div>
            </template>
          </float-label>
          <float-label label="Nombre:">
            <input
              v-model="usuario.nombre"
              id="nombre"
              placeholder="Ingresar un nombre..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.usuario.nombre.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.usuario.nombre.required"
              >Debe ingresar el nombre
              </div>
            </template>
          </float-label>
          <float-label label="Documento:">
            <input
              v-model="usuario.documento"
              inputmode="numeric"
              id="documento"
              placeholder="Ingresar un documento..."
              type="text"
              class="form-control"
              :class="(enviado && (!$v.usuario.documento.required || !$v.usuario.documento.numeric)) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.usuario.documento.required"
              >Debe ingresar el documento
              </div>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.usuario.documento.numeric"
              >Solo se aceptan números
              </div>
            </template>
          </float-label>
          <float-label label="Tipo:">
            <select id="tipo" v-model="usuario.tipo" class="form-control"
                    :class="(enviado && !$v.usuario.tipo.required) ? 'is-invalid' : ''">
              <option value="null">Seleccione una opción</option>
              <option value="Vendedor">Vendedor</option>
              <option value="Administrador">Administrador</option>
            </select>
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.usuario.tipo.required"
              >Debe seleccionar el tipo
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import {required, numeric} from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Usuario from "@/models/usuario";

export default {
  name: "NuevoUsuario",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel
  },
  data() {
    return {
      usuario: new Usuario(null, "", "", null),
      loading: false,
      enviado: false
    };
  },
  validations: {
    usuario: {
      nombre: {required},
      documento: {required, numeric},
      denominacion: {required},
      tipo: {required}
    }
  },
  methods: {
    guardarUsuario() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/users", this.usuario)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.usuario.nombre} se guardó con éxito.`
            });
            this.$router.push({name: "ListarUsuarios"});
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
